import { pageTitles } from '@/constants/pageTitles';

import ContactBlock from './ContactBlock';
import styles from './ContactFaqBlock.module.scss';

const ContactFaqBlock: React.FC = () => (
  <ContactBlock>
    <p>
      スタディサプリ for
      PARENTSに関するよくある質問は下記よりご確認いただけます。お問い合わせの前にご覧ください。
    </p>
    <a
      href="https://studysapuri-school.jp/studentfaq/s/"
      rel="noopener noreferrer"
      target="_blank"
      className={styles.link}
    >
      {pageTitles.contact}
    </a>
  </ContactBlock>
);

export default ContactFaqBlock;
